import { hasCapability, type User } from "../base";

export const livePhotoReview = {
  read: (user: User) => hasCapability(user, "livePhotoReview.read"),
  update: (user: User) => hasCapability(user, "livePhotoReview.update"),
};
